import {DetailHead, DetailLines, DetailSummary, UiMessage} from '@components/export';
import {useLabel} from '@/hooks/export';

export const Detail = (props: {
    loading: boolean,
    item: apiProductDetail | apiOrderDetail,
    additionalPaymentList: apiOrderLine[],
    mode: 'product' | 'order',

    onItemFieldUpdate: (field: string, value: any) => void,
    onItemLineUpdate: (field: string, value: any, id: string) => void,
    onAdditionalPaymentAdd: (lineId: string, paymentId: string) => void,
    onItemGoToOrder: (id: string) => void,
}) => {
    const label = useLabel();

    return <div className={cmpClass}>
        {
            props.loading && !props.item ?
                <UiMessage type={'loading'} text={label.loading} /> :
                !props.item ?
                    <UiMessage type={'interaction'} text={getInteractionMessage(props.mode, label)} /> :
                    <>
                        <DetailHead
                            mode={props.mode}
                            item={props.item}
                            loading={props.loading}

                            onReadyForCollectUpdate={(value) => props.onItemFieldUpdate('readyForCollect', value)}
                        />
                        <DetailLines
                            mode={props.mode}
                            loading={props.loading}
                            lines={props.item.lines}
                            additionalPaymentList={props.additionalPaymentList}

                            onLineUpdate={(field, value, id) => props.onItemLineUpdate(field, value, id)}
                            onItemGoToOrder={(id) => props.onItemGoToOrder(id)}
                            onAdditionalPaymentAdd={(lineId, paymentId) => props.onAdditionalPaymentAdd(lineId, paymentId)}
                        />
                        {
                            props.mode === 'order' ?
                                <DetailSummary
                                    item={(props.item as apiOrderDetail)}

                                    onNoteUpdate={(value) => props.onItemFieldUpdate('note', value)}
                                /> : <></>
                        }
                    </>
        }
    </div>;
};

const cmpClass = 'detail';

const getInteractionMessage = (mode: string, label: {[name: string]: string}) => {
    switch (mode) {
        case 'order':
            return label.selectOrder;
        case 'product':
            return label.selectProduct;
        case 'report':
            return label.selectMonthAndYear;
    }
};
